import { FC } from 'react';
import BGImage from 'src/components/common/BGImage';
import Meta from 'src/components/common/Meta';
import StrapiRichText from 'src/components/common/StrapiRichText';
import { IStrapiRichText } from 'src/components/common/StrapiRichText/StrapiRichText.type';
import useResponsive from 'src/hooks/contexts/useResponsive';
import Flex from 'src/styles/layouts/Flex';
import { EFlex } from 'src/styles/layouts/Flex/Flex.enum';
import Main from 'src/styles/layouts/Main';
import NGHeading from 'src/styles/theme/components/NGHeading';
import { ETextTransform, ETextType } from 'src/styles/theme/components/NGText/NGText.enum';
import { EMediaQuery, ESize, ETextColor } from 'src/styles/theme/utils/enums';
import { StyledContentContainer, StyledTextContainer } from './LegalPage.styles';
import { ILegalPage } from './LegalPage.type';

const LegalPage: FC<ILegalPage> = ({ id, title, type, description, slug, coverUrl }) => {
	const { isSmallerThanMd } = useResponsive();

	return (
		<>
			<Meta title={title} />

			<Main
				paddingY={ESize['3xl']}
				mdPaddingY={ESize['3xl']}
				smPaddingY={52}
				marginTop={ESize['l']}
				smMarginTop={ESize['s']}
				singlePage
			>
				{!isSmallerThanMd ? (
					<BGImage hiddenRange={[EMediaQuery.md, undefined]} src='/assets/textures/background-1.webp' />
				) : (
					<BGImage hiddenRange={[undefined, EMediaQuery.md]} src='/assets/textures/mobile-background.webp' />
				)}

				<Flex
					direction={EFlex.column}
					vertical={EFlex.start}
					horizontal={EFlex.start}
					smPaddingLeft={ESize['3xs']}
					fullWidth
					fullHeight
				>
					<NGHeading
						type={ETextType.h1}
						textColor={ETextColor.gold}
						textTransform={ETextTransform.capitalize}
						marginBottom={ESize.xs}
						width='100%'
					>
						{title}
					</NGHeading>

					<StyledContentContainer>
						<StyledTextContainer>
							{description?.length
								? description.map((element: IStrapiRichText) => {
										return (
											<StrapiRichText
												key={element.id}
												type={element.type}
												data={element.data}
												contentTagUpdated={element.contentTagUpdated}
												headerColor={ETextColor.gold}
											/>
										);
								  })
								: null}
						</StyledTextContainer>
					</StyledContentContainer>
				</Flex>
			</Main>
		</>
	);
};

export { LegalPage };
